import { useLocation, Link } from 'react-router-dom';
import { encrypt } from '../../helpers/crypto';
import { ErrorPageProps } from './ErrorPageProps';
import { useTranslation } from 'react-i18next';

const ErrorPage = (props: ErrorPageProps) => {
  const { code, message } = props;
  const errorCode = code || 500;
  const { t } = useTranslation();
  const messages = {
    500: t('errorPage.error'),
    404: t('errorPage.notFound'),
    403: t('errorPage.forbidden'),
  };

  const time = new Date().toISOString();
  const location = useLocation();
  const requestId = encrypt(`${time}:${location.pathname}`, true);
  return (
    <div
      className={
        'flex flex-col justify-center items-center text-center w-full h-full dark:bg-black'
      }
    >
      <img alt="merlin" src="/merlin-logo-lime.svg" className={'w-1/4'} />
      <h1 className={'dark:text-white font-bold text-xl mt-12'}>
        Oops, an error has occurred...
      </h1>
      <h2 className={'text-grey-50 mt-4'}>
        {message ? message : messages[errorCode]}
        <br />
        <Link
          className={'dark:text-white underline hover:font-semibold'}
          to={'/'}
        >
          Go to website homepage
        </Link>
      </h2>
      <div className={'text-grey-70 truncate w-96 text-xxs mt-36'}>
        RequestId: {requestId}
      </div>
    </div>
  );
};

export default ErrorPage;
